import type { Theme } from './interface/detailed';

const DEFAULT_TEXT_COLOR = '#222733';

const FIELD_TEXT_COLOR = '#222B55';

const DEFAULT_FIELDS_BORDER = '1px solid #DBDDE4';
const DEFAULT_FIELDS_BORDER_RADIUS = '8px';
const DEFAULT_SECONDARY_BUTTON_COLOR = '#AFB3C0';
const DEFAULT_PRIMARY_BUTTON_COLOR = '#fff';
const ORANGE = '#FF9162';
const ORANGE_SECONDARY = '#FFE8DE';
const ORANGE_THIRDLY = '#fc8849';
const DEFAULT_FIELD_PADDING = '10px 16px';
export const DEFAULT_FONT_FAMILY =
	'-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell","Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

const SECONDARY_TEXT_COLOR = '#7B829A';

const defaultTheme: Theme = {
	prechat: {
		header: {
			prechatHeader: {
				fontSize: '16px',
				fontFamily: 'inherit',
				color: '#fff',
				lineHeight: '16px',
				letterSpacing: '0.5px',
			},
		},
		checkboxes: {
			personalAgreement: {
				checkboxBackgroundColor: '#fff',
				checkboxColor: '#4DBA6E',
				labelColor: DEFAULT_TEXT_COLOR,
				labelLinkColor: ORANGE,
				labelFontSize: '12px',
				labelFontFamily: 'inherit',
				labelLineHeight: '14px',
				checkboxBorderColor: '#aaa',
				marginTop: '5px',
				marginBottom: '5px',
				onFocusBorder: ORANGE,
			},
		},
		buttons: {
			startConversationButton: {
				backgroundColor: ORANGE,
				borderRadius: '8px',
				color: '#fff',
				padding: '8px 14px',
				fontSize: '14px',
				lineHeight: '16px',
				fontFamily: 'inherit',
				fontWeight: 700,
			},
		},
	},
	blockedChat: {
		header: {
			blockedHeader: {
				fontSize: '16px',
				fontFamily: 'inherit',
				color: 'white',
				lineHeight: '16px',
				letterSpacing: '0.5px',
			},
		},
	},
	offlineChat: {
		header: {
			offlinePrechatHeader: {
				fontSize: '16px',
				fontFamily: 'inherit',
				color: '#fff',
				lineHeight: '16px',
				letterSpacing: '0.5px',
			},
		},
		checkboxes: {
			personalAgreement: {
				checkboxBackgroundColor: '#fff',
				checkboxColor: '#4DBA6E',
				labelColor: DEFAULT_TEXT_COLOR,
				labelLinkColor: DEFAULT_TEXT_COLOR,
				labelFontSize: '12px',
				labelFontFamily: 'inherit',
				labelLineHeight: '14px',
				checkboxBorderColor: '#aaa',
				marginTop: '5px',
				marginBottom: '5px',
				onFocusBorder: ORANGE,
			},
		},
		buttons: {
			startConversationButton: {
				backgroundColor: ORANGE,
				borderRadius: '8px',
				color: '#fff',
				padding: '8px 14px',
				fontSize: '14px',
				lineHeight: '16px',
				fontFamily: 'inherit',
				fontWeight: 700,
			},
			gratitudeButton: {
				backgroundColor: ORANGE,
				borderRadius: '8px',
				color: '#fff',
				padding: '8px 14px',
				fontSize: '14px',
				lineHeight: '16px',
				fontFamily: 'inherit',
				fontWeight: 700,
			},
		},
	},
	chat: {
		icons: {
			deleteAttachmentIcon: {
				width: '22px',
				height: '22px',
				fill: '#afb3c0',
			},
			pendingMessageIcon: {
				fill: 'rgba(255,255,255,.5)',
				size: '10px',
			},
			messageDeliveredIcon: {
				fill: 'rgba(255,255,255,.5)',
				size: '10px',
			},
			messageReadIcon: {
				fill: 'rgba(255,255,255,.5)',
				height: '12px',
				width: '16px',
			},
			smileIcon: {
				panelActiveColor: '#333',
				size: '21px',
				panelClosedColor: '#AFB3C0',
			},
			messageAttachmentIcon: {
				fill: DEFAULT_SECONDARY_BUTTON_COLOR,
				size: '21px',
				colorOnFocus: ORANGE,
			},
		},
		buttons: {
			selectionButton: {
				border: `1px solid ${ORANGE}`,
				backgroundColor: '#fff',
				color: ORANGE,
				borderRadius: '100px',
				fontSize: '14px',
				fontFamily: 'inherit',
				lineHeight: '20px',
				padding: '8px 12px',
				margin: '5px 3px',
			},
			newQuestion: {
				border: '1px solid transparent',
				backgroundColor: ORANGE,
				margin: '0 16px 10px 16px',
				color: '#fff',
				borderRadius: '8px',
				fontSize: '14px',
				fontFamily: 'inherit',
				padding: '8px 14px',
				hoverBackgroundColor: 'darkorange',
			},
			messageSendIcon: {
				margin: '0',
				color: DEFAULT_PRIMARY_BUTTON_COLOR,
				backgroundColor: ORANGE,
				width: '32px',
				height: '32px',
				padding: '8px',
				borderRadius: '30px',
				border: 'none',
				outline: `1px solid ${ORANGE}`,
			},
			sendDialogToEmail: {
				sendDialogToEmailButton: {
					backgroundColor: '#ff9162',
					borderRadius: '8px',
					color: 'white',
					fontSize: '14px',
					margin: '16px 0 0 0',
					lineHeight: '16px',
					padding: '8px',
				},
				cancelSendingDialogButton: {
					color: '#7b829a',
					fontSize: '14px',
					fontWeight: 500,
					margin: '16px 0 0 0',
					lineHeight: '1',
				},
				returnToMainScreenButton: {
					backgroundColor: '#ff9162',
					borderRadius: '8px',
					color: '#fff',
					fontSize: '14px',
					lineHeight: '16px',
					padding: '8px 24px',
				},
			},
			scrollToBottom: {
				backgroundColor: '#fff',
				arrowColorInActive: ORANGE,
				arrowColorInInactive: '#ccc',
				border: '1px solid #ccc',
				onHoverBorder: ORANGE,
				size: '22px',
				padding: '3px',
				borderRadius: '50%',
				bottom: '20px',
				right: '20px',
			},
		},
		header: {
			select: {
				option: {
					color: '#222b55',
					fontSize: '14px',
					fontWeight: 400,
					lineHeight: '24px',
					padding: '10px 13px',
					hoverBackgroundColor: '#eee',
					backgroundColor: '#fff',
				},
				screenShareIcon: {
					fill: '#FF9162',
					height: '24px',
					width: '24px',
				},
				sendToEmailIcon: {
					fill: '#FF9162',
					height: '24px',
					width: '24px',
				},
			},
			chatHeader: {
				fontWeight: 700,
				fontSize: '16px',
				fontFamily: 'inherit',
				color: '#fff',
				lineHeight: '20px',
				letterSpacing: 'initial',
			},
			agentName: {
				fontSize: '14px',
				lineHeight: '1.4',
				fontWeight: 500,
				color: 'white',
				padding: '0 0 6px 0',
				letterSpacing: '0.2px',
			},
			agentRole: {
				fontSize: '12px',
				lineHeight: '12px',
				fontWeight: 500,
				color: '#FFDED0',
				padding: '0',
				letterSpacing: '0.2px',
			},
			agentTextWrapper: {
				padding: '0 0 0 16px',
			},
			agentAvatarWrapper: {
				backgroundColor: '#e2e2e2',
				borderRadius: '50%',
				height: '36px',
				width: '36px',
				minWidth: '36px',
			},
			agentAvatar: {
				borderRadius: '50%',
				height: '36px',
				width: '36px',
			},
		},
		systemMessages: {
			systemMessage: {
				fontSize: '14px',
				fontFamily: 'inherit',
				lineHeight: '17px',
				margin: '10px 0',
				padding: '5px',
				color: '#AFB3C0',
			},
			connectionCorruptedErrorMessage: {
				lineHeight: '30px',
				fontSize: '12px',
				fontFamily: 'inherit',
				color: 'red',
			},
		},
		dateDelimiter: {
			fontSize: '16px',
			lineHeight: '18.75px',
			fontWeight: 400,
			fontFamily: 'inherit',
			color: '#AFB3C0',
			padding: '24px 0',
			textAlign: 'center',
			textTransform: 'uppercase',
		},
		dateDelimiterSticky: {
			fontSize: '16px',
			lineHeight: '18.75px',
			fontWeight: 400,
			fontFamily: 'inherit',
			color: '#7b829a',
			backgroundColor: '#edeef1',
			padding: '4px 8px 4px 12px',
			borderRadius: '8px',
			textTransform: 'uppercase',
			top: '4px',
		},
		messages: {
			messageContainer: {
				padding: '0',
			},
			message: {
				padding: '8px 12px',
				agentColor: DEFAULT_TEXT_COLOR,
				clientColor: '#fff',
				linkColor: 'blue',
				fontSize: '14px',
				fontFamily: 'inherit',
				lineHeight: '20px',
				agentBackgroundColor: '#F5F8FF',
				clientBackgroundColor: ORANGE_THIRDLY,
				borderRadius: '8px',
				boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.06), 0px 4px 4px rgba(34, 43, 85, 0.06)',
			},
			suggestion: {
				backgroundColor: '#fff',
				color: ORANGE,
				lineHeight: '20px',
				padding: '12px 0',
				fontSize: '14px',
				fontFamily: 'inherit',
			},
			messageTime: {
				fontWeight: 500,
				fontSize: '10px',
				lineHeight: '10px',
				fontFamily: 'inherit',
				colorClient: 'rgba(255,255,255,.5)',
				colorOperator: '#9B9FA8',
				padding: '5px 0 0 0',
			},
			agentName: {
				fontSize: '12px',
				lineHeight: '12px',
				fontWeight: 500,
				fontFamily: 'inherit',
				color: '#777C87',
				padding: '0 3px 8px',
				letterSpacing: '0.2px',
			},
		},
		replyMessage: {
			replyMessageScope: {
				agentReplyMessageColor: '#222B55',
				agentReplyDelimiterColor: '#222B55',
				clientReplyMessageColor: '#ffffff',
				clientReplyDelimiterColor: '#faddb2',
				fontSize: '13px',
				lineHeight: '20px',
				fontFamily: 'inherit',
			},
			replySenderName: {
				agentNameColor: '#222B55',
				clientNameColor: '#ffffff',
				fontFamily: 'inherit',
				lineHeight: '20px',
				fontSize: '13px',
				fontWeight: '700',
			},
			replyPreviewContainer: {
				borderTop: DEFAULT_FIELDS_BORDER,
				messageColor: '#222B55',
				senderColor: '#222B55',
				fontFamily: 'inherit',
				fontSize: '13px',
				lineHeight: '20px',
				padding: '5px 16px',
				replyIconSize: '18px',
				replyIconColor: '#AFB3C0',
				replyCloseIconSize: '20px',
				replyCloseIconColor: '#AFB3C0',
			},
		},
		attachments: {
			unsentAttachmentPreview: {
				padding: '12px 16px',
				fontSize: '16px',
				fontFamily: 'inherit',
				lineHeight: '20px',
				color: '#222B55',
			},
			unsentImagePreview: {
				padding: '0',
				height: '30px',
				width: 'auto',
				opacity: '0.6',
			},
			attachmentsPreviewContainer: {
				borderTop: DEFAULT_FIELDS_BORDER,
				padding: '0',
			},
		},
	},
	ratingField: {
		icons: {
			ratingIcon: {
				fill: '#FBCE1B',
				height: '22px',
				width: '22px',
				padding: '5px',
			},
		},
		text: {
			ratingLabel: {
				fontSize: '16px',
				fontFamily: 'inherit',
				fontWeight: 'bold',
				lineHeight: '24px',
				letterSpacing: '0.1px',
				padding: '5px 10%',
				color: '#fff',
				width: '100%',
			},
		},
		containers: {
			ratingIconsContainer: {
				padding: '15px 0',
			},
			darkenedContainer: {
				backgroundColor: 'rgb(34, 43, 85)',
				opacity: 0.93,
			},
		},
	},
	afterRatingField: {
		text: {
			afterRatingHeader: {
				color: 'white',
				lineHeight: '24px',
				fontSize: '16px',
				fontFamily: 'inherit',
				fontWeight: 'bold',
			},
			afterRatingText: {
				color: 'white',
				lineHeight: '24px',
				fontSize: '14px',
				fontFamily: 'inherit',
				fontWeight: 'initial',
			},
			afterRatingButton: {
				color: 'white',
				lineHeight: '24px',
				fontSize: '14px',
				fontFamily: 'inherit',
				fontWeight: 'initial',
				borderBottom: '1px dashed white',
			},
		},
		containers: {
			afterRatingContainer: {
				backgroundColor: 'rgb(34, 43, 85)',
				opacity: 0.93,
			},
		},
	},
	questionnaireField: {
		buttons: {
			sendQuestionnaireButton: {
				backgroundColor: ORANGE,
				borderRadius: '8px',
				color: '#fff',
				padding: '8px 16px',
				fontFamily: 'inherit',
				fontSize: '14px',
				fontWeight: 700,
				width: '100%',
				margin: '0 0 16px 0',
			},
			afterQuestionnaireButton: {
				backgroundColor: '#ff9162',
				borderRadius: '8px',
				color: '#fff',
				fontSize: '14px',
				fontWeight: 'bold',
				lineHeight: '16px',
				margin: '8px 0',
				padding: '8px 12px',
				fontFamily: 'inherit',
			},
		},
		checkboxes: {
			questionnaireAgreement: {
				checkboxBackgroundColor: '#fff',
				checkboxColor: '#4DBA6E',
				labelColor: DEFAULT_TEXT_COLOR,
				labelLinkColor: DEFAULT_TEXT_COLOR,
				labelFontSize: '12px',
				labelFontFamily: 'inherit',
				labelLineHeight: '14px',
				checkboxBorderColor: '#aaa',
				marginTop: '5px',
				marginBottom: '5px',
				onFocusBorder: ORANGE,
			},
		},
		text: {
			afterQuestionnaireContainer: {
				backgroundColor: '#fff',
			},
			afterQuestionnaireMessage: {
				fontSize: '14px',
				letterSpacing: '0.1px',
				lineHeight: '24px',
				padding: '8px',
				textAlign: 'center',
				color: 'black',
				fontFamily: 'inherit',
			},
			afterQuestionnaireHeader: {
				fontSize: '16px',
				fontWeight: 'bold',
				lineHeight: '24px',
				color: 'black',
				fontFamily: 'inherit',
				textAlign: 'center',
			},
		},
		header: {
			questionnaireHeader: {
				fontSize: '16px',
				fontFamily: 'inherit',
				color: '#fff',
				lineHeight: '20px',
				fontWeight: 'bold',
				padding: '0 20px',
			},
		},
	},
	allSettings: {
		modalNotifications: {
			button: {
				backgroundColor: '#ff9162',
				color: '#fff',
			},
			header: {
				color: '#222B55',
				fontSize: '16px',
				lineHeight: 1,
			},
			errorText: {
				color: '#222B55',
				fontSize: '14px',
				lineHeight: '20px',
			},
			container: {
				backgroundColor: '#fff',
			},
		},
		fields: {
			common: {
				borderRadius: DEFAULT_FIELDS_BORDER_RADIUS,
				marginBottom: '15px',
				background: 'transparent',
				border: DEFAULT_FIELDS_BORDER,
				padding: DEFAULT_FIELD_PADDING,
				onFocusBorder: `1px solid ${ORANGE}`,
				fontSize: '14px',
				fontFamily: 'inherit',
				color: FIELD_TEXT_COLOR,
				errorColor: '#ED3945',
				lineHeight: '16px',
				height: '40px',
			},
			label: {
				fontSize: '13px',
				lineHeight: '13px',
				labelFontFamily: 'inherit',
				color: SECONDARY_TEXT_COLOR,
				paddingBottom: '7.5px',
			},
		},
		icons: {
			closeWidgetIconDesktop: {
				size: '24px',
				backgroundColor: 'rgba(34, 43, 85, 0.18)',
				padding: '14px',
				fill: '#fff',
			},
			angleDownIcon: {
				width: '20px',
				height: '20px',
				fill: '#fff',
			},
			closeWidgetIcon: {
				width: '25px',
				height: '25px',
				borderRadius: '50px',
				backgroundColor: ORANGE,
				fill: '#fff',
				padding: '13.5px',
			},
			openWidgetIcon: {
				width: '25px',
				height: '25px',
				borderRadius: '50px',
				backgroundColor: ORANGE,
				padding: '13.5px',
				fill: '#fff',
			},
			startVideocallIcon: {
				width: '25px',
				height: '25px',
				backgroundColor: ORANGE,
				fill: '#fff',
			},
			phoneIcon: {
				width: '15px',
				fill: DEFAULT_SECONDARY_BUTTON_COLOR,
			},
			mailIcon: {
				width: '15px',
				fill: DEFAULT_SECONDARY_BUTTON_COLOR,
			},
			fileIconInsideMessage: {
				width: '20px',
				height: '24px',
				backgroundColor: ORANGE_SECONDARY,
				fill: ORANGE,
			},
			fileIconInsideAttachmentPreview: {
				width: '12px',
				padding: '8px 10px',
				height: '16px',
				backgroundColor: ORANGE_SECONDARY,
				fill: ORANGE,
			},
		},
		containers: {
			mainFonts: {
				fontFamily: DEFAULT_FONT_FAMILY,
			},
			appContainer: {
				right: '20px',
				bottom: '40px',
				openBtnAndWidgetMargin: '10px',
			},
			chatContainer: {
				width: '360px',
				height: '540px',
				background: '#fff',
				borderRadius: '12px',
				boxShadow: '0 4px 28px rgba(0, 0, 0, 0.06)',
				maxResizableHeight: '630px',
				maxResizableWidth: '600px',
				minResizableHeight: '500px',
				minResizableWidth: '300px',
			},
			headerContainer: {
				padding: '16px',
				background: ORANGE,
			},
			contentContainer: {
				padding: '0',
			},
			unreadCount: {
				backgroundColor: '#4dba6e',
				borderRadius: '32px',
				color: '#fff',
				fontSize: '12px',
				height: '22px',
				minWidth: '16px',
				fontFamily: 'inherit',
				lineHeight: '22px',
				left: '70%',
				padding: '0 3px',
				bottom: '60%',
				border: 'initial',
			},
		},
		select: {
			option: {
				color: DEFAULT_TEXT_COLOR,
				fontSize: '14px',
				fontFamily: 'inherit',
				backgroundColor: 'transparent',
				hoverBackgroundColor: 'darkgrey',
			},
			multiselectSelectedOption: {
				fontSize: '14px',
				lineHeight: '16px',
				fontWeight: 400,
				fontFamily: 'inherit',
				color: '#464C59',
				backgroundColor: '#E6E7E9',
				padding: '4px 8px',
			},
		},
		attachments: {
			filename: {
				fontWeight: 'bold',
				fontSize: '14px',
				fontFamily: 'inherit',
				lineHeight: '17px',
			},
			fileDescription: {
				fontSize: '13px',
				fontFamily: 'inherit',
				lineHeight: '16px',
				agentColor: '#9B9FA8',
				clientColor: '#fff',
				margin: '4px 0',
			},
			downloadAttachButton: {
				color: '#fff',
				backgroundColor: ORANGE,
				padding: '8px 12px',
				fontSize: '12px',
				fontFamily: 'inherit',
				lineHeight: '12px',
				borderRadius: '4px',
			},
			imagePreview: {
				width: '100%',
				boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.06), 0px 4px 4px rgba(34, 43, 85, 0.06)',
				borderRadius: '12px',
			},
			attachmentError: {
				backgroundColor: 'transparent',
				fontSize: '14px',
				fontFamily: 'inherit',
				color: '#ED3945',
				lineHeight: '16px',
				padding: '8px 16px 12px',
				fontWeight: 400,
			},
		},
		loadingAnimation: {
			animationType: 'Oval',
			iconColor: '#FF9162',
			animationSize: '30px',
		},
	},
	videoCalls: {
		icons: {
			fullscreenIcon: {
				width: '20px',
				height: '20px',
				fill: 'white',
				backgroundColor: 'rgba(255,255,255,.2)',
			},
			normalscreenIcon: {
				width: '20px',
				height: '20px',
				fill: 'white',
				backgroundColor: 'rgba(255,255,255,.2)',
			},
			startVideocallIcon: {
				width: '24px',
				height: '24px',
				fill: 'white',
				backgroundColor: 'transparent',
			},
			microphoneIcon: {
				width: '20px',
				height: '20px',
				fill: 'white',
				backgroundColor: 'rgba(255,255,255,.2)',
			},
			microphoneSlashedIcon: {
				width: '20px',
				height: '20px',
				fill: '#222B55',
				backgroundColor: '#fff',
			},
			videoIcon: {
				width: '20px',
				height: '20px',
				fill: 'white',
				backgroundColor: 'rgba(255,255,255,.2)',
			},
			videoSlashedIcon: {
				width: '20px',
				height: '20px',
				fill: '#222B55',
				backgroundColor: '#fff',
			},
			phoneIcon: {
				width: '21px',
				height: '21px',
				fill: 'white',
				backgroundColor: '#ED3945',
			},
			switchCameraIcon: {
				width: '20px',
				height: '20px',
				fill: 'white',
				backgroundColor: 'rgba(255,255,255,.2)',
			},
		},
	},
};

export { defaultTheme };
